import { invalidateProjectCounters } from "~/repository/projectUtils";
import {
  ADD_TASK_SUCCESS,
  COMPLETE_TASK_SUCCESS,
  OPEN_TASK_SUCCESS,
  MOVE_TASK_TO_TRASH_SUCCESS,
  RESTORE_TASK_FROM_TRASH_SUCCESS,
  DUPLICATE_TASK_SUCCESS,
  MOVE_TASK_TO_PROJECT_SUCCESS,
  ADD_TASK_FROM_RECURRING_TASK_SUCCESS,
  MOVE_TASK_LIST_TO_TRASH_SUCCESS,
  COMPLETE_TASK_LIST_SUCCESS,
  DUPLICATE_TASK_LIST_SUCCESS,
  MOVE_TASK_LIST_TO_PROJECT_SUCCESS,
  ADD_TASK_LIST_SUCCESS,
  INSERT_TASK_LIST_SUCCESS,
  BATCH_EDIT_TASKS_SUCCESS,
  BATCH_EDIT_EXPENSES_SUCCESS,
  BATCH_EDIT_TIME_RECORDS_SUCCESS,
  ADD_TIME_RECORD_SUCCESS,
  DELETE_TIME_RECORD_SUCCESS,
  ADD_EXPENSE_SUCCESS,
  MOVE_EXPENSE_TO_TRASH_SUCCESS,
  ADD_DISCUSSION_SUCCESS,
  CONVERT_DISCUSSION_TO_TASK_SUCCESS,
  MOVE_DISCUSSION_TO_TRASH_SUCCESS,
  RESTORE_DISCUSSION_FROM_TRASH_SUCCESS,
  MOVE_DISCUSSION_TO_PROJECT_SUCCESS,
  ADD_NOTE_SUCCESS,
  MOVE_NOTE_TO_PROJECT_SUCCESS,
  DUPLICATE_NOTE_SUCCESS,
  MOVE_NOTE_TO_TRASH_SUCCESS,
  RESTORE_NOTE_FROM_TRASH_SUCCESS,
  ADD_FOLDER_SUCCESS,
  MOVE_TO_TRASH_SUCCESS,
  RESTORED_FROM_TRASH_SUCCESS,
  ADD_FILES_SUCCESS,
  MOVE_EXPENSE_SUCCESS,
  MOVE_TIME_RECORD_SUCCESS,
  ADD_TASK_FROM_CONVERSATION_SUCCESS,
  BATCH_ADD_TASKS_SUCCESS,
} from "~/store/action_types/index.jsx";

const projectCountersMiddleware = () => (next) => (action) => {
  const { type } = action;
  switch (type) {
    case RESTORE_TASK_FROM_TRASH_SUCCESS:
    case MOVE_TASK_TO_TRASH_SUCCESS:
    case OPEN_TASK_SUCCESS:
    case COMPLETE_TASK_SUCCESS:
    case COMPLETE_TASK_LIST_SUCCESS:
    case MOVE_TASK_LIST_TO_TRASH_SUCCESS:
    case ADD_TIME_RECORD_SUCCESS:
    case DELETE_TIME_RECORD_SUCCESS:
    case ADD_EXPENSE_SUCCESS:
    case MOVE_EXPENSE_TO_TRASH_SUCCESS:
    case MOVE_DISCUSSION_TO_TRASH_SUCCESS:
    case RESTORE_DISCUSSION_FROM_TRASH_SUCCESS:
    case MOVE_NOTE_TO_TRASH_SUCCESS:
    case RESTORE_NOTE_FROM_TRASH_SUCCESS: {
      const { response } = action;
      const { single } = response;
      invalidateProjectCounters(single.project_id);

      return next(action);
    }
    case ADD_TASK_FROM_CONVERSATION_SUCCESS: {
      const { attributes } = action;
      invalidateProjectCounters(attributes.project_id);

      return next(action);
    }
    case RESTORED_FROM_TRASH_SUCCESS:
    case MOVE_TO_TRASH_SUCCESS: {
      const { response, objectType } = action;
      const { single } = response;
      if (objectType === "Folder" || objectType === "File") {
        invalidateProjectCounters(single.project_id);
      }

      return next(action);
    }
    case ADD_TASK_SUCCESS:
    case ADD_TASK_FROM_RECURRING_TASK_SUCCESS:
    case ADD_TASK_LIST_SUCCESS:
    case DUPLICATE_TASK_SUCCESS:
    case DUPLICATE_TASK_LIST_SUCCESS:
    case INSERT_TASK_LIST_SUCCESS:
    case CONVERT_DISCUSSION_TO_TASK_SUCCESS:
    case ADD_DISCUSSION_SUCCESS:
    case ADD_NOTE_SUCCESS:
    case DUPLICATE_NOTE_SUCCESS:
    case ADD_FOLDER_SUCCESS:
    case ADD_FILES_SUCCESS:
    case BATCH_ADD_TASKS_SUCCESS: {
      const { projectId } = action;
      invalidateProjectCounters(projectId);

      return next(action);
    }
    case MOVE_TIME_RECORD_SUCCESS:
    case MOVE_EXPENSE_SUCCESS: {
      const { projectId, task_id } = action;
      if (!task_id) {
        invalidateProjectCounters(projectId);
      }

      return next(action);
    }
    case MOVE_TASK_LIST_TO_PROJECT_SUCCESS:
    case MOVE_TASK_TO_PROJECT_SUCCESS:
    case MOVE_DISCUSSION_TO_PROJECT_SUCCESS:
    case MOVE_NOTE_TO_PROJECT_SUCCESS: {
      const { projectId, newProjectId, copy } = action;
      if (!copy) {
        invalidateProjectCounters(projectId);
      }
      invalidateProjectCounters(newProjectId);
      return next(action);
    }
    case BATCH_EDIT_TASKS_SUCCESS: {
      const { projectId, attributes } = action;
      if (attributes?.move_all || attributes?.trash_all || attributes?.complete_all) {
        invalidateProjectCounters(projectId);
      }
      return next(action);
    }
    case BATCH_EDIT_TIME_RECORDS_SUCCESS:
    case BATCH_EDIT_EXPENSES_SUCCESS: {
      const { projectId } = action;
      if (action?.move_all || action?.trash_all) {
        invalidateProjectCounters(projectId);
      }
      return next(action);
    }
    default:
      return next(action);
  }
};

export default projectCountersMiddleware;
